<template>
    <v-switch
        :input-value="value"
        @change="$emit('input', $event)"
        label="Ocultar eliminadas"
        hide-details
        class="mt-0 pt-0 flex-grow-0"
    />
</template>

<script>
export default {
    name: 'HideDeletedSwitch',
    props: {
        value: {
            type: Boolean,
            default: false
        }
    }
}
</script>
